import { HOME_PAGE, LINKS } from "../../constants/constants"
import "./Home.scss"

export default function Home() {
    return (
        <div className="home-section row">
            <div className="right-section d-flex align-items-center align-items-sm-start flex-column col-12 col-sm-5">
                <div className="header text-uppercase">Dinu Senal</div>
                <div className="sub-heading fw-light">Full Stack Software Engineer Based in Melbourne</div>
                <img 
                    className="img-fluid border border-primary mt-2" 
                    src="images/portrait.jpg" 
                    alt="profile-img"           
                    style={{ maxHeight: "15rem", width: "16rem" }} 
                />
            </div>
            <div className="left-section col-12 col-sm-7 mt-4 mt-sm-0">
                <div className="title">About Me</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.INTRODUCTION}
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">BSc (Hons) Computer Science</div>
                <div className="date h4 mt-1">2018 - 2022</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.GRAD_INTRODUCTION}
                </div>
                <div className="links mt-2">
                    <a href={LINKS.IIT} target="_blank" rel="noreferrer" className="btn btn-outline-primary">
                        IIT
                    </a>
                    <a href={LINKS.UOW} target="_blank" rel="noreferrer" className="btn btn-outline-primary mx-3">
                        UOW
                    </a>
                    <a href={LINKS.ECERT} target="_blank" rel="noreferrer" className="btn btn-outline-primary mt-3 mt-sm-0">
                        E-Certificate
                    </a>
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Freelancer</div>
                <div className="date h4 mt-1">2019 - 2020</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.FREELANCE_INTRODUCTION}
                </div>
                <div className="links mt-2">
                    <a href={LINKS.INFORMATES} target="_blank" rel="noreferrer" className="btn btn-outline-primary">
                        Informates
                    </a>
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Internship at Avantrio</div>
                <div className="date h4 mt-1">2020-08-10 - 2021-08-18</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.INTERN_INTRODUCTION}
                </div>
                <div className="links mt-2">
                    <a href={LINKS.AVANTRIO} target="_blank" rel="noreferrer" className="btn btn-outline-primary">
                        Avantrio
                    </a>
                    <a href={LINKS.VERSTEAD} target="_blank" rel="noreferrer" className="btn btn-outline-primary ms-3">
                        Verstead
                    </a>
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Associate Software Engineer at Avantrio</div>
                <div className="date h4 mt-1">2022-06-01 - 2023-10-01</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.ASSOCIATE_INTRODUCTION}
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Software Engineer at Avantrio</div>
                <div className="date h4 mt-1">2023-11-01 - 2024-02-01</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.SOFTWARE_ENGINEER_INTRODUCTION}
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Medium Article Writer</div>
                <div className="date h4 mt-1">2023-12 - Present</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.MEDIUM_ARTICLE_WRITER}
                </div>
                <div className="links mt-2">
                    <a href={LINKS.MEDIUM} target="_blank" rel="noreferrer" className="btn btn-outline-primary">
                        MEDIUM
                    </a>
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Master of Information Technology</div>
                <div className="date h4 mt-1">2024-02 - 2025-12</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.MASTER_INTRODUCTION}
                </div>
                <div className="links mt-2">
                    <a href={LINKS.RMIT} target="_blank" rel="noreferrer" className="btn btn-outline-primary">
                        RMIT
                    </a>
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Programming Instructor - Junior Engineers - St Catherine's School, Toorak, VIC</div>
                <div className="date h4 mt-1">2024-04-17 - Present</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.INSTRUCTOR_INTRODUCTION}
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title">Software Engineer - UrbixHub</div>
                <div className="date h4 mt-1">2025-08-01 - 2025-12-25</div>
                <div className="description fw-light mt-2">
                    {HOME_PAGE.URBIXHUB_INTRODUCTION}
                </div>
                <div className="links mt-2">
                    <a href={LINKS.URBIXHUB} target="_blank" rel="noreferrer" className="btn btn-outline-primary">
                        URBIXHUB
                    </a>
                </div>
                <div className="border-seperator my-3"></div>

                <div className="title text-uppercase text-center">
                    Be Part of My Journey
                </div>

            </div>
        </div>
    )
}